export default "__VITE_ASSET__DWLrn96g__"